import React from "react";
import { Controller } from "react-hook-form";
import { Input } from "../../shared/components/UI";
import Icon from "../../components/V2/Icon/Icon";

class InputService {
  constructor(control, errors) {
    this.control = control;
    this.errors = errors || {};
  }

  renderInput({
    name,
    type = "text",
    placeholder,
    header,
    internalOnChange = null,
    disabled = false,
    loading = false,
    ...rest
  }) {
    return (
      <div className={`input-container ${name}-input ${disabled ? "input-container-disabled" : ""} ${loading ? "input-loading" : ""}`}>
        <Controller
          name={name}
          control={this.control}
          render={({ field: { onChange, ...field } }) => (
            <Input
              {...field}
              {...rest}
              disabled={disabled}
              onChange={(e) => {
                if (disabled) return;
                onChange(e);
                if (internalOnChange) {
                  internalOnChange(e);
                }
              }}
              placeholder={placeholder}
              header={header}
              type={type}
              errors={{ [name]: this.errors?.[name]?.message || "" }}
            />
          )}
        />
        <div className="icon-container">
          {loading ? (
            <div className="input-spinner"></div>
          ) : name === "card_number" ? (
            <Icon name="card" color="input-icon" width={20} height={16} />
          ) : name === "security_code" ? (
            <button
              type="button"
              className="help-tooltip"
              aria-label="O que é o código de segurança?"
            >
              <Icon name="help" color="input-icon" width={20} height={20} />
              <span className="help-tooltip-text" role="tooltip">
                Os 3 dígitos no verso do seu cartão.
              </span>
            </button>
          ) : name === "postal_code" ? (
            <Icon name="search" color="input-icon" size={20} />
          ) : null}
        </div>
      </div>
    );
  }
}

export default InputService;
